<template>
  <Popper :hover="true" placement="top">
    <i class="bi bi-info-circle"></i>
    <template #content>
      <div class="card shadow">
        <div class="card-header">
          <h5 class="card-title my-auto"><slot name="header"></slot></h5>
        </div>
        <div class="card-body">
          <p class="card-text">
            <slot name="body"></slot>
          </p>
        </div>
      </div>
    </template>
  </Popper>
</template>

<script>
import Popper from "vue3-popper";
export default {
  components: {
    Popper,
  },
};
</script>

<style></style>
